import { RbiOrderStatus } from '@fhs-legacy/frontend/src/generated/rbi-graphql';

export const OrderStatus = RbiOrderStatus;
export const FIRE_REQUESTED = 'FIRE_REQUESTED' as const;
export const FIRE_SUCCESSFUL = 'FIRE_SUCCESSFUL' as const;
export type OrderSubmittedStatus = `${RbiOrderStatus}` | typeof FIRE_REQUESTED | typeof FIRE_SUCCESSFUL;

export const ORDER_SUBMITTED_STATUSES = new Set([
  RbiOrderStatus.PAYMENT_REQUESTED,
  RbiOrderStatus.PAYMENT_SUCCESSFUL,
  RbiOrderStatus.INSERT_REQUESTED,
  RbiOrderStatus.INSERT_SUCCESSFUL,
  FIRE_REQUESTED,
  FIRE_SUCCESSFUL,
]) as ReadonlySet<OrderSubmittedStatus>;
